<template>
  <div>
    <v-menu v-model="showCalendar" transition="scale-transition" offset-y right max-width="290px" min-width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          hide-details
          :value="date"
          class="date-field mr-0 pl-4"
          :class="{
            'secondary lighten-3': disabled,
            'primary darken-1': !disabled
          }"
          outlined
          readonly
          :disabled="disabled"
          :label="label"
          v-on="on"
          single-line
          v-bind="attrs"
        >
          <template v-slot:append>
            <v-btn fab depressed x-small :disabled="disabled" color="transparent" class="disable-hover-bg" :ripple="false" v-on="on">
              <v-icon color="white" class="transparent">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </template>
      <v-date-picker color="primary darken-1" v-model="date" scrollable :min="min" :allowed-dates="allowedDates">
        <v-spacer></v-spacer>
        <v-btn small color="primary darken-1" @click="showCalendar = false">Cancel</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { uiHelper } from '@/utils'
export default {
  props: {
    value: String,
    label: { default: 'Date' },
    disabled: { type: Boolean, default: false },
    availableDates: { type: Array, required: false },
    min: { type: String, default: uiHelper.getTodayDate() }
  },

  data: () => ({
    showCalendar: false,
    date: ''
  }),

  watch: {
    date(val) {
      this.$emit('input', val)
    }
  },
  created() {
    this.date = this.value ? this.value : this.min
  },

  methods: {
    allowedDates(val) {
      return this.availableDates.includes(val)
    }
  }
}
</script>

<style lang="scss">
.v-date-picker-header .v-btn--icon .v-icon {
  background-color: transparent !important;
}

.date-field .v-input__control > .v-input__slot {
  .v-label,
  input {
    color: white;
  }

  fieldset {
    /* outline color */
    color: transparent !important;
  }

  .v-input__append-inner {
    margin-top: auto !important;
    margin-bottom: auto !important;

    /* disabled button style */
    .v-btn--disabled.v-btn--disabled {
      background-color: transparent !important;
      span i {
        color: white !important;
      }
    }
  }
}
</style>
